const Point2Illustration = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 0H8C3.58172 0 0 3.58172 0 7.99999V48.0003C0 52.4186 3.58171 56.0003 7.99999 56.0003H47.9999C52.4182 56.0003 55.9999 52.4186 55.9999 48.0003V8C55.9999 3.58172 52.4182 0 48 0Z"
      fill="#FFCCEF"
    />
    <path d="M32.0837 42H23.917V56.0001H32.0837V42Z" fill="#0A0777" />
    <path d="M32.0837 0H23.917V14.0001H32.0837V0Z" fill="#0A0777" />
    <path
      d="M14 32.0842L14 23.9175L-1.52588e-05 23.9175L-1.56158e-05 32.0842L14 32.0842Z"
      fill="#0A0777"
    />
    <path
      d="M56 32.0842L56 23.9175L42 23.9175L42 32.0842L56 32.0842Z"
      fill="#0A0777"
    />
    <path
      d="M28 49.0002C39.598 49.0002 49 39.5982 49 28.0001C49 16.4021 39.598 7 28 7C16.402 7 7 16.4021 7 28.0001C7 39.5982 16.402 49.0002 28 49.0002Z"
      fill="white"
    />
    <path
      d="M27.9997 39.667C34.443 39.667 39.6664 34.4436 39.6664 28.0002C39.6664 21.5569 34.443 16.3335 27.9997 16.3335C21.5564 16.3335 16.333 21.5569 16.333 28.0002C16.333 34.4436 21.5564 39.667 27.9997 39.667Z"
      fill="#FB6E44"
    />
  </svg>
);

export default Point2Illustration;
